module.exports = __webpack_public_path__ + "static/ShopDashboard-7ac10bef6b264d2e0d2bec7e03e09660.png";